import {Component, OnInit} from '@angular/core';
import {NgForm} from '@angular/forms';
import {HttpClient} from '@angular/common/http';
import {FooterServices} from './_services/footer.services';

interface MailChimpResponse {
    result: string;
    msg: string;
}

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

    constructor(private http: HttpClient, private footerService: FooterServices) {
    }

    loggedIn: string;

    isLoggedIn: boolean;
    haveCompany: boolean;

    submitted = false;

    mailChimpEndpoint = 'https://agribusinessjob.us1.list-manage.com/subscribe/post-json?u=03f98ef9f1a1fd8a77c767f2d&amp;id=3819e65e79';
    hiddenInput = 'b_03f98ef9f1a1fd8a77c767f2d_3819e65e79'


    ngOnInit() {

        this.loggedIn = localStorage.getItem("loggedIn");
        
        if(this.loggedIn === 'true'){

        this.footerService.checkIfUserIsLoggedIn().subscribe((data) => {
            this.isLoggedIn = true;
            this.footerService.checkIfUserHaveCompany().subscribe((resp: any) => {
                this.haveCompany = resp !== null;
            })
        }, error => {
            this.isLoggedIn = false;
        })
    }
    }

    subMailChimp(subForm: NgForm) {

        const userEmail = subForm.value.email
        const mailChimpUrl = this.mailChimpEndpoint + '&EMAIL=' + userEmail + '&' + this.hiddenInput;

        this.http.jsonp<MailChimpResponse>(mailChimpUrl, 'c').subscribe((response: any) => {
            this.submitted = true;
        }, error => {
        });
    }

}
